import { render } from "./MainTabComponent.view.vue?vue&type=template&id=309d6c12"
import script from "./MainTabComponent.view.vue?vue&type=script&lang=js"
export * from "./MainTabComponent.view.vue?vue&type=script&lang=js"

import "./MainTabComponent.view.vue?vue&type=style&index=0&id=309d6c12&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__